import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckOverrideItemPriceRequest } from 'Src/feature/check/models';
import { getTypedFormComponents } from 'Src/feature/form/getTypedFormComponents';
import { useForm } from 'Src/feature/form/useForm';
import { Modal } from 'Src/feature/modal/Modal';
import { ModalAction } from 'Src/feature/modal/ModalAction';
import { ModalActions } from 'Src/feature/modal/ModalActions';
import { ModalContent } from 'Src/feature/modal/ModalContent';
import { ModalHeader } from 'Src/feature/modal/ModalHeader';
import { ModalTitle } from 'Src/feature/modal/ModalTitle';

import styles from './CheckItemEditPriceModal.module.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const sectionId = 'CheckItemEditPriceModal';
const TEST_ID = {
  root: 'CheckItemEditPriceModal-test',
} as const;

interface CheckItemEditPriceModalProps {
  open: boolean;
  form: ReturnType<typeof useForm<CheckOverrideItemPriceRequest>>,
  basePrice: number;
  onClose: () => void;
  onSave: () => void;
}

const { Form, Field } = getTypedFormComponents<CheckOverrideItemPriceRequest>();

const CheckItemEditPriceModal: FC<CheckItemEditPriceModalProps> = ({
  open,
  form,
  basePrice,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation();
  const price = form.state.watch('price')?.toString();

  return (
    <Modal
      data-testid={TEST_ID.root}
      open={open}
      onBackDropClick={onClose}
      variant="grow"
    >
      <ModalHeader>
        <ModalTitle copy={t('labels.editPrice')} />
      </ModalHeader>

      <ModalContent>
        <Form usedForm={form}>
          <Field
            type="currencyInput"
            name="price"
            placeholder={basePrice?.toFixed(2).toString()}
            className={styles['currency-input']}
          />
          <Field
            type="text"
            name="note"
            variant="underline"
            label={t('labels.note')}
          />
        </Form>
      </ModalContent>

      <ModalActions>
        <ModalAction
          label={t('labels.cancel')}
          onClick={onClose}
          color="secondary"
        />
        <ModalAction
          label={t('labels.save')}
          onClick={onSave}
          color="primary"
          disabled={!(price !== '0.00' && form.state.isDirty)}
        />
      </ModalActions>

    </Modal>
  );
};

export { CheckItemEditPriceModal, TEST_ID };
